module.exports = __webpack_public_path__ + "Roboto-Light-webfont.d8472f7b6012706fc028.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.ttf
// module chunks = 1